import {Form} from "antd";
import DgForm from "../../../custom/data-entry/form";
import Content from "./content";
import {useDispatch, useSelector} from "react-redux";
import {addWeighingStation} from "../../../api/weighingStation";
import {onChangeVisibleDrawerAdmin, onReloadData} from "../../../redux/actions/layout/interaction/action";
import {useState} from "react";

const Add = ({onLoading})=>{

    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const { reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [status, setStatus] = useState("inactive")
    const onFinish = (value) => {

        value ={
            ...value,
            status : status,
            customerId : value.customerId !== null || value.customerId !== 0 ? value.customerId : 0
        }
        onLoading(true)
        addWeighingStation(value).then(r =>{
            dispatch(onChangeVisibleDrawerAdmin(undefined))
            dispatch(onReloadData(!reloadData))
            onLoading(false)
        })
            .catch(ex=>{
                onLoading(false)
            })
    }

    return (
        <>
            <DgForm
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >

                <Content form={form}
                         customer={true}
                         status={status}
                         setStatus={(value) => setStatus(value ? "active" : "inactive")}/>
            </DgForm>
        </>
    )
}

export default Add
